(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // Header scroll state
  const header = $('.header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Reveal on scroll
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });
  $$('.reveal').forEach(el => io.observe(el));

  // Accordion
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.accordion__btn');
    if (!btn) return;
    const item = btn.closest('.accordion__item');
    const isOpen = item.classList.contains('is-open');
    $$('.accordion__item', item.parentElement).forEach(i => i.classList.remove('is-open'));
    if (!isOpen) item.classList.add('is-open');
  });

  // Mobile menu
  const mobileMenu = $('.mobile-menu');
  const lockBody = (lock) => { document.body.classList.toggle('is-locked', lock); };
  const openMobileMenu = () => { mobileMenu?.classList.add('is-open'); $('.overlay')?.classList.add('is-open'); lockBody(true); };
  const closeMobileMenu = () => { mobileMenu?.classList.remove('is-open'); if (!$('.cart-drawer')?.classList.contains('is-open')) $('.overlay')?.classList.remove('is-open'); lockBody(false); };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-mobile-menu-toggle]')) { e.preventDefault(); openMobileMenu(); }
    if (e.target.closest('[data-mobile-menu-close]')) { e.preventDefault(); closeMobileMenu(); }
  });

  // Quantity stepper (product page only — not cart lines)
  $$('[data-qty]').forEach(wrap => {
    if (wrap.hasAttribute('data-line-qty')) return;
    const input = $('input', wrap);
    if (!input) return;
    $('[data-qty-minus]', wrap)?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    $('[data-qty-plus]', wrap)?.addEventListener('click', () => {
      input.value = parseInt(input.value || '1', 10) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // Gallery
  $$('[data-gallery]').forEach(gallery => {
    const mainImg = $('[data-gallery-main] img', gallery);
    $$('[data-gallery-thumb]', gallery).forEach(thumb => {
      thumb.addEventListener('click', () => {
        $$('[data-gallery-thumb]', gallery).forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const fullSrc = thumb.dataset.full || thumb.querySelector('img').src;
        if (mainImg) mainImg.src = fullSrc;
      });
    });
  });

  // Variant picker
  $$('[data-product-form]').forEach(form => {
    let variants = [];
    try { variants = JSON.parse(form.dataset.variants || '[]'); } catch (e) {}

    const formatMoney = (cents) => {
      const amount = (cents / 100).toFixed(2);
      return (window.Shopify?.currency?.symbol || '$') + amount;
    };

    const updatePrice = (variant) => {
      const section = form.closest('section');
      if (!section) return;
      const priceEl = section.querySelector('[data-price]');
      if (priceEl && variant) priceEl.textContent = formatMoney(variant.price);
      const compareEl = section.querySelector('[data-compare-price]');
      if (compareEl) {
        if (variant && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
    };

    const updateVariant = () => {
      const selected = $$('button[data-option-input].is-active', form).map(b => b.dataset.optionValue);
      const match = variants.find(v => v.options.every((o, i) => o === selected[i]));
      if (match) {
        const idInput = $('[data-variant-id]', form);
        if (idInput) idInput.value = match.id;
        updatePrice(match);
        const submitBtn = $('[data-add-to-cart]', form);
        if (submitBtn) {
          submitBtn.disabled = !match.available;
          if (match.available) {
            submitBtn.innerHTML = 'add to bag ✿ ' + formatMoney(match.price);
          } else {
            submitBtn.textContent = 'sold out';
          }
        }
      }
    };

    $$('button[data-option-input]', form).forEach(btn => {
      btn.addEventListener('click', () => {
        const group = btn.dataset.optionGroup;
        $$(`button[data-option-input][data-option-group="${group}"]`, form).forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const label = btn.closest('.option')?.querySelector('[data-selected-option]');
        if (label) label.textContent = btn.dataset.optionValue.toLowerCase();
        updateVariant();
      });
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submitBtn = $('[data-add-to-cart]', form);
      const original = submitBtn.innerHTML;
      submitBtn.textContent = 'adding...';
      submitBtn.disabled = true;
      try {
        const formData = new FormData(form);
        const res = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } });
        if (!res.ok) throw new Error('add failed');
        const cartData = await res.json();
        if (typeof fbq === 'function') {
          fbq('track', 'AddToCart', {
            content_name: cartData.title || '',
            content_ids: [String(cartData.id || '')],
            content_type: 'product',
            value: (cartData.final_price || 0) / 100,
            currency: window.Shopify?.currency?.active || 'USD'
          });
        }
        await refreshCart();
        toast('added to bag ✿');
        openDrawer();
      } catch (err) {
        toast('something went wrong');
      } finally {
        submitBtn.innerHTML = original;
        submitBtn.disabled = false;
      }
    });
  });

  // Cart drawer open/close
  const getDrawer = () => $('.cart-drawer');
  const getOverlay = () => $('.overlay');
  const openDrawer = () => { getDrawer()?.classList.add('is-open'); getOverlay()?.classList.add('is-open'); lockBody(true); };
  const closeDrawer = () => { getDrawer()?.classList.remove('is-open'); if (!mobileMenu?.classList.contains('is-open')) getOverlay()?.classList.remove('is-open'); lockBody(false); };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
    if (e.target.classList?.contains('overlay')) { closeDrawer(); closeMobileMenu(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeDrawer(); closeMobileMenu(); }
  });

  // Cart line quantity & remove (delegated)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-qty-line-change]');
    if (btn) {
      e.preventDefault();
      const key = btn.dataset.key;
      const dir = btn.dataset.direction;
      const line = btn.closest('[data-cart-line]');
      const input = line?.querySelector('input');
      const current = parseInt(input?.value || '1', 10);
      const next = dir === 'up' ? current + 1 : Math.max(0, current - 1);
      await updateLine(key, next);
      return;
    }
    const removeLink = e.target.closest('[data-line-remove]');
    if (removeLink) {
      e.preventDefault();
      await updateLine(removeLink.dataset.key, 0);
      return;
    }
    const bundleBtn = e.target.closest('[data-bundle-add]');
    if (bundleBtn) {
      e.preventDefault();
      bundleBtn.textContent = 'adding';
      try {
        const formData = new FormData();
        formData.append('id', bundleBtn.dataset.variantId);
        formData.append('quantity', '1');
        const bundleRes = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } });
        if (bundleRes.ok && typeof fbq === 'function') {
          const bundleData = await bundleRes.json();
          fbq('track', 'AddToCart', {
            content_name: bundleData.title || '',
            content_ids: [String(bundleData.id || '')],
            content_type: 'product',
            value: (bundleData.final_price || 0) / 100,
            currency: window.Shopify?.currency?.active || 'USD'
          });
        }
        await refreshCart();
        toast('added to bag ✿');
      } catch (err) { toast('try again'); bundleBtn.textContent = 'add'; }
      return;
    }
  });

  async function updateLine(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!res.ok) throw new Error('update failed');
      await refreshCart();
    } catch (err) { toast('try again'); }
  }

  async function refreshCart() {
    try {
      const res = await fetch('/?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } });
      const html = await res.text();
      const newDoc = new DOMParser().parseFromString(html, 'text/html');
      const newDrawerEl = newDoc.querySelector('.cart-drawer');
      const existingDrawer = getDrawer();
      if (newDrawerEl && existingDrawer) {
        const wasOpen = existingDrawer.classList.contains('is-open');
        existingDrawer.innerHTML = newDrawerEl.innerHTML;
        if (wasOpen) existingDrawer.classList.add('is-open');
      }
      const cartJson = await (await fetch('/cart.js')).json();
      $$('.cart-count').forEach(el => {
        el.textContent = cartJson.item_count;
        el.style.display = cartJson.item_count > 0 ? '' : 'none';
      });
    } catch (e) {}
  }

  // Toast
  function toast(message) {
    const root = $('#ToastRoot');
    if (!root) return;
    const item = document.createElement('div');
    item.className = 'toast__item';
    item.textContent = message;
    root.appendChild(item);
    setTimeout(() => { item.style.opacity = '0'; setTimeout(() => item.remove(), 300); }, 2400);
  }

  // Before/After slider (touch + mouse)
  $$('[data-beforeafter]').forEach(ba => {
    const after = ba.querySelector('.beforeafter__after');
    const handle = ba.querySelector('.beforeafter__handle');
    const knob = ba.querySelector('.beforeafter__knob');
    let active = false;
    const setPos = (clientX) => {
      const rect = ba.getBoundingClientRect();
      const pct = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
      if (after) after.style.clipPath = `inset(0 0 0 ${pct}%)`;
      if (handle) handle.style.left = `${pct}%`;
      if (knob) knob.style.left = `${pct}%`;
    };
    ba.addEventListener('pointerdown', (e) => { active = true; try { ba.setPointerCapture(e.pointerId); } catch (_) {} setPos(e.clientX); });
    ba.addEventListener('pointermove', (e) => { if (active) setPos(e.clientX); });
    ba.addEventListener('pointerup', () => { active = false; });
    ba.addEventListener('pointercancel', () => { active = false; });
  });

  // Sticky ATC
  const stickyAtc = $('.sticky-atc');
  const productForm = $('[data-product-form]');
  if (stickyAtc && productForm) {
    const trigger = productForm.closest('section');
    if (trigger) {
      const ioAtc = new IntersectionObserver((entries) => {
        entries.forEach(e => stickyAtc.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0));
      }, { threshold: 0 });
      ioAtc.observe(trigger);
    }
    $('[data-sticky-atc-btn]', stickyAtc)?.addEventListener('click', () => {
      productForm.requestSubmit ? productForm.requestSubmit() : productForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  // Meta Pixel: InitiateCheckout on checkout link clicks (cart page + cart drawer)
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href="/checkout"], a[href*="/checkout"]');
    if (link && typeof fbq === 'function') {
      fbq('track', 'InitiateCheckout', {
        content_type: 'product',
        currency: window.Shopify?.currency?.active || 'USD'
      });
    }
  });

  // Meta Pixel: Lead on newsletter signup
  const newsletterForm = $('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', () => {
      if (typeof fbq === 'function') {
        fbq('track', 'Lead', { content_name: 'Newsletter Signup' });
      }
    });
  }

  // Meta Pixel: CompleteRegistration on customer account creation
  if (document.body.classList.contains('template-customers-register') || document.querySelector('form[action*="/account"]')) {
    document.querySelectorAll('form[action*="/account"]').forEach(regForm => {
      if (regForm.querySelector('input[name="customer[password]"]')) {
        regForm.addEventListener('submit', () => {
          if (typeof fbq === 'function') {
            fbq('track', 'CompleteRegistration', { content_name: 'Customer Account' });
          }
        });
      }
    });
  }

  // Collection page filters
  $$('[data-filter-chip]').forEach(chip => {
    chip.addEventListener('click', () => {
      $$('[data-filter-chip]').forEach(c => c.classList.remove('is-active'));
      chip.classList.add('is-active');
    });
  });
})();
